import { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import Cheque from '../../../../../Models/Cheque';
import VerifDay from '../../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';

//import '../../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

const RemiseBank = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [DataCheque, setDataCheque] = useState<Cheque[]>([]);
    // const [DataOperationV, setDataOperationV] = useState<DataHistoCpt[]>([]);
    const [StartRef, SetStartRef] = useState(false);
    const Navigate=useNavigate();

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
             GetAllSaisieAgence(); 
            let DateD = user.datjour;
            form.setFieldValue("DATOPE", DateD);
            VerifDay(user.coduti,user.codage,authHeader,Navigate);
            SetStartForm(false);
        }
    }, []);


    function initialiazeButton() {
        setAjoutActif(false)
        setModifActve(true)
        setEnregActve(true)
        setConsulActive(false)
    }

    function cunsultButton() {
        //setAnnulActive(false)
        setSbmit("add");
        setModifActve(false);
        SetStartRef(true);
        setEnregActve(false);
        // SetActivetabs(true)
    }

    const GetAllSaisieAgence = async () => {
       // console.log("yete")

        setLoad(true);
        setDataCheque([]);

        let data = Crypter.encrypt(form.getFieldValue("NUMCLI"));
        let clearNumcli = form.getFieldValue("NUMCLI");
        let libelle = form.getFieldValue("lib_NUMCLI");

        if (data.length != 0) {
            initialiazeButton()

            form.resetFields();
            form.setFieldsValue({ "NUMCLI": clearNumcli, "lib_NUMCLI": libelle });
            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetChequeAccount,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherNumcli': data,
                    'CypherAgence': Crypter.encrypt(user.codage),
                    'CypherOption': Crypter.encrypt('2'),

                }
            }

            await
                axios(config)
                    .then((response) => {
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            if (res.StatutCode == 200) {
                                let datas = res.Result;
                                console.log(datas)

                                const Datat: Cheque[] = [];
                                if (datas.length === 0) {
                                    SweetAlert.fire({ title: "Warning", text: "Aucun élément", icon: "warning" })
                                }
                                else {
                                    res.Result.map((data: any, indice: number) => {
                                        Datat.push({
                                            key: indice,
                                            Id: data.Id,
                                            CODOPE: data.CODOPE,
                                            NUMCPT: data.NUMCPT,
                                            Client: data.NUMCLI +'--'+ data.lib_NUMCLI,
                                            NUMCHQ: data.NUMCHQ,
                                            CPTCHQRECOUVRE:data.CPTCHQRECOUVRE,
                                            BANCLT: data.BANCLT,
                                            DATOPE: data.DATOPE,
                                            MONTAN: formatNumber(data.MONTAN),
                                            LIBECR: data.LIBECR,
                                            REMETT: data.REMETT,
                                            CPTBAN: data.CPTBAN,
                                            NUMBAN: data.NUMBAN,
                                            CPTCLT: data.CPTCLT,
                                            DATSAI: data.DATSAI,
                                            BORDER: data.BORDER,
                                            DATVAL: data.DATVAL,
                                            CPTJNX: data.CPTJNX,
                                            CDETAT: data.CDETAT,
                                            CPTCHC: data.CPTCHC,
                                            AGCCPT: data.AGCCPT,
                                            NBRIMPAIE: data.NBRIMPAIE,
                                            CPTRECOUVRE: data.CPTRECOUVRE,
                                            MTESCOMPTE: data.MTESCOMPTE,
                                            CPTENCCOR: data.CPTENCCOR,
                                            VALNONPAIPRE: data.VALNONPAIPRE,
                                            cptescompte: data.cptescompte,
                                            Lib_BANQUE: data.BANCLT + "-" + data.lib_BANCLT,
                                            RelObject: data
                                        });

                                        setDataCheque(Datat);
                                    })
                                }
                            } else SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                     
                        }
                        //  setLoad(false);
                    }).catch((error) => {
                        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                    })
            setLoad(false);
        }
    }

  
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Remise chèque à la banque
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} DataCheque={DataCheque} OnModif={cunsultButton} />,
        }
    ]

    const onFinish = (values: any) => {
       
   
        let Cheque: Cheque = values;
        Cheque.LIBECR=values.lib_CODOPE;
        Cheque.DATOPE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Cheque.UTISAI=user.coduti;
        Cheque.CODAGE=user.codage;
    
        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Remise Chèque",
                text: "Voulez-vous  effectuer Remise Chèque du Montant de : " + formatNumber(form.getFieldValue('MONTAN')) + ' XAF ' + " à la banque : " + form.getFieldValue('BANCLT') + "--" + form.getFieldValue('lib_BANCLT') + " ? ",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then( async (res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    //let group = profilsDistant.find(()=>)
                    let data = Crypter.encrypt(JSON.stringify(Cheque));

                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.RemiseCheque,
                        headers: {
                            'Authorization': authHeader(),
                            'Accept': '*/*',
                            'Content-Type': 'application/json',
                            'CypherOption':Crypter.encrypt('3')
                        },
                        data: data
                    };

                 await   axios.request(config)
                        .then((response) => {
                          
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    let result = res.Result;
                                    form.resetFields();
                       
                                    setIsSubmit(false);
                                    SweetAlert.fire({ title: res.Message, text: result, icon: "success" });
                                    GetAllSaisieAgence(); 
                                    setSbmit("");
                                }
                                else 
                                {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" });
                                    setLoading(false);
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                        });
                }
                setLoading(false);
            })
        }
    
        
    };


    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };


    function modifButton() {
        setModifActve(true)
        setAjoutActif(true);
        SetStartRef(true);
        setEnregActve(false)
        setConsulActive(true)
        setSbmit("update");
    }

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Remise  Chèque à la Banque cas Complet </b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                               
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' type="ghost" htmlType="button" block>
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={load} >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" onChange={(e) => { if (e == '2') { } }} defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}
export default RemiseBank;